import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import AddIcon from '@material-ui/icons/Add';
import MoreIcon from '@material-ui/icons/MoreHoriz';
import DeleteIcon from '@material-ui/icons/Delete';
import { Typography, MenuItem, Menu, Grid, IconButton } from '@material-ui/core';

const styles = theme => ({
  root: {
  },
  articleBox: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  article: {
    width: "calc(85vmin)",
  },
  link: {
    textDecoration: "none",
    color: "#333",
  }
});

class List extends React.Component {
  state = { list:[] };

  async componentDidMount() {
    const { user, db } = this.props;
    const ref = db.collection("users/" + user.uid + "/articles").orderBy("created", "desc");
    this.detacher = ref.onSnapshot((snapshot)=>{
      const list = [];
      snapshot.forEach(doc => {
        list.push({id:doc.id, ...doc.data()});
      });
      this.setState({list:list});
    });
  }

  componentWillUnmount() {
    if (this.detacher) {
      this.detacher();
    }
  }

  handleMore(e, aid) {
    this.setState({ anchorEl: e.currentTarget, context:aid });
  }

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleDelete = async () => {
    const {context} = this.state;
    const { user, db } = this.props;
    const ref = db.doc("users/" + user.uid + "/articles/" + context)
    await ref.delete();
    this.setState({ anchorEl: null });
  }

  render() {
    const { classes } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    //const path = (window.location.hostname==="localhost") ? "/a/" : "/api/a/"; 
    const path = "/a/";

    return (
      <div className={classes.root}>
        <div>
          <div key="0" className={classes.article}>
          <IconButton variant="contained" className={classes.button} component={Link} to={"/login/target/make"}>
            <AddIcon />
          </IconButton>
          </div>
          {
            this.state.list.map((item)=>{
              return <Grid container className={classes.articleBox} key={item.id}>
                        <Grid item className={classes.article}>
                          <Link className={classes.link} to={path+item.id}>
                            <Typography>{item.title || "(untitled)"}</Typography>
                          </Link>
                        </Grid>
                        <Grid className={classes.menu}>
                          <IconButton size="small" onClick={(e)=>{this.handleMore(e, item.id)}}><MoreIcon fontSize="small" /></IconButton>
                        </Grid>
                     </Grid>;
            })
          }
        </div>
        <Menu
          id="menu-appbar"
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          open={open}
          onClose={this.handleClose}
        >
          <MenuItem onClick={this.handleDelete}><DeleteIcon /></MenuItem>
        </Menu>            
      </div>
    );
  }
}

List.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(List);
